import { prefersReducedMotion, onReducedMotionChange } from "@js/parts/prefersReducedMotion";

export default function accessibleVideo() {
  return {
    playing: false,
    reducedMotion: false,
    _onPlay: null,
    _onPause: null,
    _unsubscribeMotion: null,

    init() {
      const video = this.$refs.video;
      if (!video) return;

      this.reducedMotion = prefersReducedMotion();

      this._onPlay = () => { this.playing = true; };
      this._onPause = () => { this.playing = false; };
      video.addEventListener("play", this._onPlay);
      video.addEventListener("pause", this._onPause);

      if (this.reducedMotion) {
        video.pause();
        this.playing = false;
      } else {
        this.playing = !video.paused;
      }

      this._unsubscribeMotion = onReducedMotionChange((matches) => {
        this.reducedMotion = matches;
        if (matches) {
          video.pause();
          this.playing = false;
        }
      });
    },

    toggle() {
      const video = this.$refs.video;
      if (!video) return;

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    destroy() {
      const video = this.$refs.video;
      if (video) {
        if (this._onPlay) video.removeEventListener("play", this._onPlay);
        if (this._onPause) video.removeEventListener("pause", this._onPause);
      }
      if (this._unsubscribeMotion) {
        this._unsubscribeMotion();
        this._unsubscribeMotion = null;
      }
    },
  };
}
